import script from "./FormAutoCompleteOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormAutoCompleteOptions.vue?vue&type=script&setup=true&lang=ts"

import "./FormAutoCompleteOptions.vue?vue&type=style&index=0&id=c4fc1bb8&lang=scss"

const __exports__ = script;

export default __exports__